import { fetchTicketInfo } from "@/api/tiflux";
import { TifluxServiceAdapter } from "@/usecases/tiflux/adapter/TifluxServiceAdapter";
import { injectable } from "inversify";

@injectable()
export class TifluxService implements TifluxServiceAdapter {
	fetchTicketInfo = async (numeroTicket: string) => await fetchTicketInfo(numeroTicket)
}